<template>
  <AccountModal
    v-if="showAccountModal"
    @closeModal="showAccountModal = !showAccountModal"
  />
  <div
    class="navbar navbar-dark navbar-expand-lg py-1 navbar-static border-bottom border-bottom-white border-opacity-10"
  >
    <div class="container-fluid ps-1">
      <div class="d-flex d-lg-none me-2">
        <button
          type="button"
          class="navbar-toggler sidebar-mobile-main-toggle rounded"
          title="Expandir/Recolher"
        >
          <i class="ph ph-list" />
        </button>
      </div>
      <div class="navbar-brand">
        <router-link
          to="/home"
          class="d-inline-flex align-items-center"
          title="Home"
        >
          <img
            src="@/assets/img/logos/logo_mini.png"
            class="h-32px"
            alt="Logo"
          />
          <span class="ms-2 text-white fs-lg">Portal de Relatórios</span>
        </router-link>
      </div>
      <div class="d-xl-none">
        <button
          type="button"
          class="navbar-toggler"
          data-bs-toggle="collapse"
          data-bs-target="#navbar-navigation"
          aria-expanded="true"
          title="Expandir/Recolher"
        >
          <i class="ph ph-list" />
        </button>
      </div>
      <div class="navbar-collapse collapse" id="navbar-navigation">
        <ul class="navbar-nav ms-auto">
          <li class="nav-item dropdown ms-xl-1">
            <a
              href="#"
              class="navbar-nav-link rounded dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {{ user && user.nome ? user.nome : 'Usuário não identificado' }}
            </a>
            <div class="dropdown-menu dropdown-menu-end">
              <template v-if="!isEthos">
                <button
                  class="dropdown-item"
                  @click="showAccountModal = true"
                  title="Meu Perfil"
                >
                  <i class="ph ph-user me-2" />Meu Perfil
                </button>
                <div class="dropdown-divider"></div>
              </template>
              <button class="dropdown-item" @click="logout" title="Sair">
                <i class="ph ph-sign-out me-2" />Sair
              </button>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import AccountModal from '@/components/company/account/AccountModal.vue'
import { mapGetters } from 'vuex'
import TipoUsuarioEnum from '@/enums/tipoUsuarioEnum'
import PATHS from '@/router/routesMap'

export default {
  name: 'Navbar',

  components: {
    AccountModal,
  },

  data() {
    return {
      showAccountModal: false,
    }
  },

  computed: {
    ...mapGetters(['user']),

    isEthos() {
      return this.user && Number(this.user.tipo) === TipoUsuarioEnum.ETHOS
    },
  },

  methods: {
    logout() {
      this.$store.dispatch('logout').then(() => {
        localStorage.clear()
        this.$router.push(PATHS.SIGN_IN)
      })
    },
  },
}
</script>
